const FALLBACK_SITE_URL = 'https://cssbuybr.wtf';

export interface SeoInput {
  title: string;
  description?: string;
  keywords?: string;
  canonical?: string;
  ogType?: string;
  ogImage?: string;
}

export function getSiteUrl(): string {
  const env = import.meta.env.VITE_SITE_URL;
  return env && env.trim() !== '' ? env.trim().replace(/\/$/, '') : FALLBACK_SITE_URL;
}

function upsertMeta(attr: 'name' | 'property', key: string, content: string | null | undefined) {
  const selector = `meta[${attr}="${key}"]`;
  let el = document.head.querySelector<HTMLMetaElement>(selector);

  if (!content) {
    if (el) el.remove();
    return;
  }

  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertCanonical(href: string | null | undefined) {
  const selector = 'link[rel="canonical"]';
  let el = document.head.querySelector<HTMLLinkElement>(selector);

  if (!href) {
    if (el) el.remove();
    return;
  }

  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function applySeo(input: SeoInput) {
  document.title = input.title;

  upsertMeta('name', 'description', input.description);
  upsertMeta('name', 'keywords', input.keywords);
  upsertCanonical(input.canonical);

  upsertMeta('property', 'og:title', input.title);
  upsertMeta('property', 'og:description', input.description);
  upsertMeta('property', 'og:url', input.canonical);
  upsertMeta('property', 'og:type', input.ogType ?? 'website');

  upsertMeta('name', 'twitter:title', input.title);
  upsertMeta('name', 'twitter:description', input.description);

  upsertMeta('property', 'og:image', input.ogImage);
  upsertMeta('name', 'twitter:image', input.ogImage);
}